import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9105692a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "logo-wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "them-wrapper p-1 _pointer-on-hover rounded-full hover:text-gray-700 hover:bg-gray-200 dark:hover:bg-gray-700 dark:hover:text-white"
}
const _hoisted_7 = { class: "right" }
const _hoisted_8 = { class: "chat-wrapper" }

import { computed, PropType, ref } from 'vue'
import ControlButton from '@/components/room/ControlButton.vue'
import useTheme from '@/composables/useTheme'
import { MoonIcon, SunIcon } from '@heroicons/vue/24/outline'
import useAuth from '@/composables/api/useAuth'
import { logoPathDark, logoPathLight, logoIcon } from '@/data/room'
import { IParticipantCapabilities } from '@/types/interfaces/participant.interface'
import LessonPopup from '@/components/room/LessonPopup.vue'
import LeavePopup from '@/components/room/LeavePopup.vue'
import { Engine } from '@/types/enums/room.enum'

interface RoomControlEmits {
  (e: 'toggle-doc', value: boolean): void
  (e: 'toggle-whiteboard', value: boolean): void
  (e: 'toggle-chat', value: boolean): void
  (e: 'toggle-sticker', value: boolean): void
  (e: 'toggle-game', value: boolean): void
  (e: 'toggle-help'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WherebyNavbar',
  props: {
  userPermissions: {
    type: Object as PropType<IParticipantCapabilities>,
    required: true,
  },
  documentEnable: {
    type: Boolean,
    default: false,
  },
  whiteboardEnable: {
    type: Boolean,
    default: false,
  },
  stickerEnable: {
    type: Boolean,
    default: false,
  },
  chatEnable: {
    type: Boolean,
    default: false,
  },
  gameEnable: {
    type: Boolean,
    default: false,
  },
  nCompartments: {
    type: Number,
    default: 1,
  },
  exitPath: {
    type: String,
    default: '',
  },
  haveTrackLesson: {
    type: Boolean,
    default: false,
  },
  chatNotifyCount: {
    type: Number,
    default: 0,
  },
  showHelp: {
    type: Boolean,
    default: false,
  },
  canChangeTheme: {
    type: Boolean,
    default: false,
  },
  engine: {
    type: String as PropType<Engine>,
    default: () => Engine.WHEREBY,
  },
},
  emits: ["toggle-doc", "toggle-whiteboard", "toggle-chat", "toggle-sticker", "toggle-game", "toggle-help"],
  setup(__props, { emit: __emit }) {

const { getAccessInfo } = useAuth()

const props = __props
const emit = __emit
/**
 * State
 */
const { isDark, changeTheme } = useTheme()
const isOpenedLessonPopup = ref(false)
const isSavedLesson = ref(false)
const isOpenedLeavePopup = ref(false)
const isFromLessonBtn = ref(false)
const lessonTooltip = ref(false)
const classId = ref(parseInt(sessionStorage.getItem('external_room_id') || ''))
/**
 * Computed
 */
const logo = computed(() => (isDark.value ? logoPathDark : logoPathLight))
const showTrackLesson = computed(
  () =>
    !!classId.value &&
    !isNaN(classId.value) &&
    props.userPermissions?.trackLesson &&
    props.haveTrackLesson,
)

/**
 * Methods
 */

const goToMainPage = () => {
  const { queryToken } = getAccessInfo()
  window.location.href = `/?token=${queryToken}`
}

const clickLeaveButton = (fromlessonBtn?: boolean) => {
  isFromLessonBtn.value = fromlessonBtn || false
  if (showTrackLesson.value) {
    isOpenedLessonPopup.value = true
  } else {
    isOpenedLeavePopup.value = true
  }
}

const submitLessonSuccess = () => {
  isSavedLesson.value = true
  if (isFromLessonBtn.value) return
  isOpenedLeavePopup.value = true
}

const clickLeaveFromLessonPopup = () => {
  isOpenedLessonPopup.value = false
  isOpenedLeavePopup.value = true
}

return (_ctx: any,_cache: any) => {
  const _component_LanguageDropdown = _resolveComponent("LanguageDropdown")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          class: "_prevent-text-select logo",
          src: logo.value,
          draggable: "false",
          onClick: goToMainPage
        }, null, 8, _hoisted_4),
        _createElementVNode("img", {
          class: "_prevent-text-select logo-icon",
          src: _unref(logoIcon),
          draggable: "false",
          onClick: goToMainPage
        }, null, 8, _hoisted_5)
      ]),
      (__props.canChangeTheme)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_unref(isDark))
              ? (_openBlock(), _createBlock(_unref(MoonIcon), {
                  key: 0,
                  "aria-hidden": "true",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(changeTheme)('light')))
                }))
              : (_openBlock(), _createBlock(_unref(SunIcon), {
                  key: 1,
                  "aria-hidden": "true",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(changeTheme)('dark')))
                }))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_LanguageDropdown, {
        class: "language-dropdown-navbar",
        "by-theme": ""
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(LeavePopup, {
          modelValue: isOpenedLeavePopup.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOpenedLeavePopup).value = $event)),
          "exit-path": __props.exitPath
        }, null, 8, ["modelValue", "exit-path"])
      ])),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        _createVNode(LessonPopup, {
          modelValue: isOpenedLessonPopup.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isOpenedLessonPopup).value = $event)),
          "class-id": classId.value,
          "is-from-lesson-btn": isFromLessonBtn.value,
          onSuccess: submitLessonSuccess,
          onLeave: clickLeaveFromLessonPopup
        }, null, 8, ["modelValue", "class-id", "is-from-lesson-btn"])
      ])),
      (__props.userPermissions?.doc && __props.engine !== _unref(Engine).VICOLLO)
        ? (_openBlock(), _createBlock(ControlButton, {
            key: 0,
            name: "Doc",
            icon: "doc",
            disabled: !__props.documentEnable,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('toggle-doc', !__props.documentEnable)))
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (__props.userPermissions?.engder)
        ? (_openBlock(), _createBlock(ControlButton, {
            key: 1,
            name: "Game",
            icon: "game",
            disabled: !__props.gameEnable,
            "is-ready": __props.nCompartments == 1,
            onClick: _cache[5] || (_cache[5] = ($event: any) => (emit('toggle-game', !__props.gameEnable)))
          }, null, 8, ["disabled", "is-ready"]))
        : _createCommentVNode("", true),
      (__props.userPermissions?.sticker)
        ? (_openBlock(), _createBlock(ControlButton, {
            key: 2,
            name: "Sticker",
            icon: "sticker",
            disabled: !__props.stickerEnable,
            onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('toggle-sticker', !__props.stickerEnable)))
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        (__props.userPermissions?.chat)
          ? (_openBlock(), _createBlock(ControlButton, {
              key: 0,
              name: "Chat",
              icon: "chat",
              disabled: !__props.chatEnable,
              badge: __props.chatNotifyCount > 0 ? `${__props.chatNotifyCount}` : '',
              onClick: _cache[7] || (_cache[7] = ($event: any) => (emit('toggle-chat', !__props.chatEnable)))
            }, null, 8, ["disabled", "badge"]))
          : _createCommentVNode("", true)
      ]),
      (showTrackLesson.value)
        ? (_openBlock(), _createBlock(_component_Popper, {
            key: 3,
            show: isSavedLesson.value ? lessonTooltip.value : false,
            hover: true,
            arrow: true,
            content: _ctx.$t('lesson-tooltip'),
            onMouseover: _cache[9] || (_cache[9] = ($event: any) => (lessonTooltip.value = true)),
            onMouseleave: _cache[10] || (_cache[10] = ($event: any) => (lessonTooltip.value = false))
          }, {
            default: _withCtx(() => [
              _createVNode(ControlButton, {
                class: "lesson-button",
                name: _ctx.$t('lesson'),
                icon: "pen",
                disabled: true,
                onClick: _cache[8] || (_cache[8] = ($event: any) => (clickLeaveButton(true)))
              }, null, 8, ["name"])
            ]),
            _: 1
          }, 8, ["show", "content"]))
        : _createCommentVNode("", true),
      (__props.showHelp)
        ? (_openBlock(), _createBlock(ControlButton, {
            key: 4,
            name: _ctx.$t('help'),
            icon: "warning",
            disabled: true,
            class: "help-button",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (emit('toggle-help')))
          }, null, 8, ["name"]))
        : _createCommentVNode("", true),
      _createVNode(ControlButton, {
        class: "leave-button",
        name: _ctx.$t('leave-button'),
        icon: "leave",
        disabled: true,
        onClick: _cache[12] || (_cache[12] = ($event: any) => (clickLeaveButton(false)))
      }, null, 8, ["name"])
    ])
  ]))
}
}

})